import { render, staticRenderFns } from "./Lowprice.vue?vue&type=template&id=43936084&scoped=true"
import script from "./Lowprice.vue?vue&type=script&lang=js"
export * from "./Lowprice.vue?vue&type=script&lang=js"
import style0 from "./Lowprice.vue?vue&type=style&index=0&id=43936084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43936084",
  null
  
)

export default component.exports